"use client";

import { BlogCard } from '@/components/blog/blog-card';
import { RelatedPostsHeading } from './related-posts-heading';

interface Post {
  slug: string;
  title: string;
  date: string;
  image?: string;
  description?: string;
  summary?: string;
  tags?: string[];
}

interface RelatedPostsProps {
  currentSlug: string;
  posts: Post[];
}

export function RelatedPosts({ currentSlug, posts }: RelatedPostsProps) {
  const relatedPosts = posts
    .filter(p => p.slug !== currentSlug) // Exclude current post
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()) // Sort by most recent
    .slice(0, 3); // Take top 3
  
  if (relatedPosts.length === 0) {
    return null;
  }
  
  return (
    <section className="mt-12" aria-labelledby="related-posts-heading" id="related-posts-section">
      <RelatedPostsHeading id="related-posts-heading" />
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 mt-6">
        {relatedPosts.map(post => (
          <BlogCard
            key={post.slug}
            slug={post.slug}
            title={post.title}
            date={post.date}
            image={post.image}
            description={post.description || post.summary}
            summary={post.summary}
          />
        ))}
      </div>
    </section>
  );
}
